<template>
	<v-container fluid class="fill-height">
		<v-row align="center" justify="center">
			<v-col cols="12" md="8" lg="6">
				<MfaSetup 
					:user="user" 
					@mfa-setup-complete="onMfaSetupComplete"
					@skip-setup="onSkipSetup"
					@close="onClose"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import MfaSetup from '../components/MfaSetup.vue';
import orgService from '../service/org-service';

export default {
	name: 'MfaSetupPage',
	components: {
		MfaSetup
	},
	data() {
		return {
			user: null
		};
	},
	mounted() {
		// Load user data
		this.loadUser();
	},
	methods: {
		async loadUser() {
			try {
				const userData = await orgService.query("getUserById");
				this.user = userData;
			} catch (error) {
				console.error("Error loading user:", error);
				this.$router.push('/vaults');
			}
		},
		onMfaSetupComplete(updatedUser) {
			// MFA setup complete, redirect to vaults or original destination
			const redirect = this.$route.query.redirect || '/vaults';
			this.$router.push(redirect);
		},
		onSkipSetup() {
			// User skipped MFA setup (during grace period)
			const redirect = this.$route.query.redirect || '/vaults';
			this.$router.push(redirect);
		},
		onClose() {
			// Close MFA setup
			const redirect = this.$route.query.redirect || '/vaults';
			this.$router.push(redirect);
		}
	}
};
</script>

